var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayTts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 8,
    fill: "#D84022"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.5034 18.1685L13.3206 9.73365C12.7281 9.4045 12 9.83292 12 10.5107V29.7115C12 30.3893 12.7281 30.8177 13.3206 30.4886L28.5034 22.0537C30.0274 21.207 30.0274 19.0152 28.5034 18.1685Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayTts);
export default __webpack_public_path__ + "static/media/playTTS.753262a39e8caa9b2397431517df6d69.svg";
export { ForwardRef as ReactComponent };